import { cloneDeep } from 'lodash';
import { createCanvas, getImgInfoAsync } from '@/utils/file-kit';
import { DEFAULT_COLO_PARAMS, PREVIEW_SIZE } from '../constants';
import type { IIntelligentEnhanceParams, IMaskData } from '../types';

export const formatIntelligentColor = (colors: number[]): string[] => {
    const rgbaCount = colors.length / 4;
    const result: string[] = [];
    for (let i = 0; i < rgbaCount; i++) {
        const [r, g, b, a] = colors.slice(i * 4, i * 4 + 4);
        result.push(`${r},${g},${b},${a}`);
    }
    return result;
};

export const getHsl = (h?: string) => {
    const arr = new Array(3).fill(0);
    if (h) {
        arr[0] = +h;
    }
    return arr;
};

export const getColor = (h?: number) => {
    const arr = new Array(8).fill(0);
    if (h) {
        arr[arr.length - 1] = +h;
    }
    return arr;
};

export const getColorParams = (h) => {
    const params = cloneDeep(DEFAULT_COLO_PARAMS);
    Object.keys(params).forEach((item, index) => {
        params[item] = getColor(index === 0 ? h : '');
    });
    return params;
};

export const hslPickColors2Colors = (hslPickColors: number[]) => {
    const params = cloneDeep(DEFAULT_COLO_PARAMS);
    Object.keys(params).forEach((item, index) => {
        params[item] = getColor(hslPickColors[index]);
    });
    return params;
};

export const getRatioImage = async (url) => {
    const { img, width, height } = await getImgInfoAsync(url);
    const ratio = PREVIEW_SIZE / width;
    const { canvas } = createCanvas(PREVIEW_SIZE, height * ratio, img);
    return canvas;
};

export const getGlParams = (data: IIntelligentEnhanceParams) => {
    const { pickColors, hslPickColors, isHslSelectAll = false, color = null, maskCode = '', fuzziness = 0 } = data;
    const params = {
        isHslSelectAll: +isHslSelectAll,
        maskCode,
    };
    if (!isHslSelectAll) {
        params['pickColors'] = pickColors ? pickColors.split(',').map((v) => +v / 255) : '';
        params['hslPickColors'] = hslPickColors;
        params['pickFuzziness'] = [fuzziness];
    } else {
        params['color'] = color;
    }
    return params;
};

export const uint8arrayToCanvas = (imageData: IMaskData) => {
    const { width, height, imagedata } = imageData;
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    const newImageData = ctx?.createImageData(width, height);
    if (imagedata && newImageData) {
        newImageData.data.set(imagedata);
        ctx?.putImageData(newImageData, 0, 0);
    }
    return canvas.toDataURL();
};
